import React, { useEffect, useState, useContext, Fragment } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Switch,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyData from "../Components/Include/EmptyData";
import {
  UPDATE_MATERIAL_IS_USE,
  GET_MATERIAL_PAGINATION,
  GET_LIST_MATERIAL_UNIT_PAGINATION,
} from "../Schema/Material";
import MaterialAction from "../Components/Material/MaterialAction";
import MaterialForm from "../Components/Material/MaterialForm";
import CreateIcon from "../Assets/create-icon.svg";
import {
  SelectCategory,
  SelectGroup,
  SelectSection,
  SelectLevelSection,
  SelectSize,
} from "../Components/Include/DynamicSelect";
import { AuthContext } from "../Context/AuthContext";
import ListMaterialUnit from "../Components/Material/ListMaterialUnit";
import ListMaterialUnitAction from "../Components/Material/ListMaterialUnitAction";
import TableViewMainItem from "../Components/Material/TableViewMainItem";
import TableViewListAllItem from "../Components/Material/TableViewListAllItem";
import ListMaterialUnitBySelectMainForm from "../Components/Material/ListMaterialUnitBySelectMainForm";

export default function MaterialUsing() {
  //==================
  const { noneUserAccesse } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);

  const [sectionVal, setSectionVal] = useState({
    id: "66b4811608714d1e00bac42a",
    title: "សម្ភារៈប្រើប្រាស់",
  });

  const [groupVal, setGroupVal] = useState({ id: "", title: "" });
  const [categoryVal, setCategoryVal] = useState({ id: "", title: "" });
  const [levelSectionVal, setLevelSectionVal] = useState({ id: "", title: "" });
  const [sizeVal, setSizeVal] = useState({ id: "", title: "" });
  const [status, setStatus] = useState(true);  

  //============== Hook Open Create Main Item ===================
  const [openCreate, setOpenCreate] = useState(false);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  //============== Hook Open Create List Item ===================
  const [openListItem, setOpenListItem] = useState(false);
  const handleOpenListItem = () => setOpenListItem(true);
  const handleCloseListItem = () => setOpenListItem(false);

  const [typeOfView,setTypeOfView] = useState('ListAllItem');
  
  useEffect( () => {
    let getTypeOfViewLocal = JSON.parse(window.localStorage.getItem('typeOfViewItem')); 
    if(getTypeOfViewLocal) {
      setTypeOfView(getTypeOfViewLocal)
    }   
  },[])

  //==============  List Item ===========
  const [listAllItem,setListAllItem] = useState([]);
  const [listAllItemPaginationData,setListAllItemPaginationData] = useState();
  const { refetch: refetchAllItem } = useQuery(GET_LIST_MATERIAL_UNIT_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      keyword,
      isUse: status === "All" ? null : status,
      categoryId: categoryVal?.id || null,
      sectionId: sectionVal?.id || null,
      groupId: groupVal?.id || null,
      levelSectionId: levelSectionVal?.id ? levelSectionVal?.id : "",
      sizeId: sizeVal?.id ? sizeVal?.id : "",
    },
    onCompleted: ({getListMaterialUnitPagination}) => {
      // console.log("getListMaterialUnitPagination:::",getListMaterialUnitPagination) 
      setListAllItem(getListMaterialUnitPagination?.data);
      setListAllItemPaginationData(getListMaterialUnitPagination?.paginator);
    },
    onError: (error) => {
      console.log(error.message)
    }
  });

  useEffect(() => {
    refetchAllItem();
    setLoading(true);
  }, [
    status,
    categoryVal?.id,
    sectionVal?.id,
    groupVal?.id,
    keyword,
    page,
    limit,
  ]);

  //=================== ===================
  const { refetch } = useQuery(GET_MATERIAL_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      keyword,
      isUse: status === "All" ? null : status,
      categoryId: categoryVal?.id || null,
      sectionId: sectionVal?.id || null,
      groupId: groupVal?.id || null,
      levelSectionId: levelSectionVal?.id ? levelSectionVal?.id : "",
      sizeId: sizeVal?.id ? sizeVal?.id : "",
    },
    onCompleted: ({ getMaterialPagination }) => {
      setTableData(getMaterialPagination?.data);
      setPaginationData(getMaterialPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      setLoading(true);
      console.log("Error::", err?.message);
    },
    pollInterval: 1000,
  });


  useEffect(() => {
    refetch();
    setLoading(true);
  }, [
    status,
    categoryVal?.id,
    sectionVal?.id,
    groupVal?.id,
    keyword,
    page,
    limit,
  ]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };


  //========== When Change Category ===========
  useEffect(() => {
    setSectionVal({
      id: "66b4811608714d1e00bac42a",
      title: "សម្ភារៈប្រើប្រាស់",
    });
    setGroupVal({ id: "", title: "" });
    setStatus(true);
    setPage(1);
  }, [categoryVal?.id]);

  //========== When Change Section ===========
  useEffect(() => {
    setGroupVal({ id: "", title: "" });
    setStatus(true);
    setPage(1);
  }, [sectionVal?.id]);

  //========== When Change Group ===========
  useEffect(() => {
    setStatus(true);
    setPage(1);
  }, [groupVal?.id]);

 


  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        {/* <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack> */}
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">សម្ភារៈប្រើប្រាស់</Typography>
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះ ឬ កូដ"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {noneUserAccesse(["Proposer"]) ? null : (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className="header-text">ជ្រើសរើសប្រភេទ</Typography>
              <SelectCategory
                className="search-field"
                setSelectedVal={setCategoryVal}
                selectedVal={categoryVal}
                isUse={false}
              />
            </Grid>
          )}

          {noneUserAccesse(["StockController", "Proposer"]) ? null : (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className="header-text">ជ្រើសរើសផ្នែក</Typography>
              <SelectSection
                className="search-field"
                setSelectedVal={setSectionVal}
                selectedVal={sectionVal}
                disabled={true}
              />
            </Grid>
          )}

          <Grid item xs={6} sm={6} md={3} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសកម្រិតផ្នែក</Typography>
            <SelectLevelSection
              className="search-field"
              selectedVal={levelSectionVal}
              setSelectedVal={setLevelSectionVal}
              isUse={false}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={2} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសក្រុម</Typography>
            <SelectGroup
              isUse={true}
              className="search-field"
              setSelectedVal={setGroupVal}
              selectedVal={groupVal}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={2} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសទំហំ</Typography>
            <SelectSize
              className="search-field"
              selectedVal={sizeVal}
              setSelectedVal={setSizeVal}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
            <Typography className="header-text">ស្ថានភាពប្រើប្រាស់</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value={true}>ប្រើប្រាស់</MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
            <Typography className="header-text">ពិនិត្យមើល</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={typeOfView}
                onChange={(e) => {
                  setTypeOfView(e.target.value)
                  window.localStorage.setItem('typeOfViewItem', JSON.stringify(e.target.value) )
                }}
              >
                <MenuItem value="MainItem">Main Item</MenuItem>
                <MenuItem value="ListAllItem">Sub-Main Item</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Box flexGrow={1} />
          <Grid item xs={6} sm={6} md={1} lg={2} xl={2}>

          {
            typeOfView === 'MainItem' &&
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenCreate}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
          } 

          {
            typeOfView === 'ListAllItem' &&
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenListItem}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
          } 

            <MaterialForm
              open={openCreate}
              handleClose={handleCloseCreate}
              setRefetch={refetch}
              dialogTitle="Create"
              defaultSectionSelected={sectionVal}
              typeOfView={typeOfView}
              handleOpenListItem={handleOpenListItem}
            />

            <ListMaterialUnitBySelectMainForm 
              openMainItem={handleOpenCreate}
              open={openListItem}
              handleClose={handleCloseListItem}
              setRefetch={refetchAllItem} 
              sectionVal={sectionVal}
              dialogTitle="Create"
            />

          </Grid>
        </Grid>
      </Box>


    { typeOfView === 'MainItem' ?
      <TableViewMainItem
        loading={loading}
        tableData={tableData} 
        paginationData={paginationData}
        refetch={refetch}
      />
    :
      <TableViewListAllItem
        tableData={listAllItem}
        paginationData={listAllItemPaginationData}
        loading={loading}
        refetch={refetchAllItem}
      />
    }

      
      <Stack
        direction="row"
        justifyContent="right"
        className="pagination-container"
      >
    {
      typeOfView === 'MainItem' ?
        <FooterPagination
          limit={limit}
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
    :
        <FooterPagination
          limit={limit}
          totalPages={listAllItemPaginationData?.totalPages}
          totalDocs={listAllItemPaginationData?.totalDocs}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
    }

      </Stack>
    </div>
  );
}
